import React from 'react';
import {Input} from "./Input";
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';

export class SelectAsync extends Input {
    constructor(props) {
        super(props);
    }


    render() {
		const AsyncComponent = this.props.creatable
			? AsyncCreatableSelect
			: AsyncSelect;

        return (
            <React.Fragment>
                <label>{this.props.label}{this.props.required ? '*' : ''}</label>
                {this.props.helpText && (
                    <small className="form-text text-muted mb-1">{this.props.helpText}</small>
                )}

                {this.props.object && (
                    <>
                        <span>{this.props.object.name}</span>
                        <button type="button" className="btn btn-link" onClick={ this.props.changeObject }>Modifier</button>
                    </>
                )}
                {!this.props.object && (
                    <AsyncComponent
                        {...this.props}
                    />
                )}
                <div className="invalid-feedback">
                    <ul className="errors">
                        {this.hasError() ? this.state.errors.map((error, index) => {
                            return <li key={index + 1}>{error}</li>
                        }) : ''}
                    </ul>
                </div>
            </React.Fragment>
        );
    }
}